import {Entity} from 'app/core/main.entity';

export class WorkerSocialLink extends Entity {
  fb: string = null;
  in: string = null;
  li: string = null;
  ok: string = null;
  tt: string = null;
  vk: string = null;
  yt: string = null;
};
